import InvoiceService from "../../services/InvoiceService";
import store from "..";

export default {
  namespaced: true, // all the state, mutations, actions, getters in this module is unique to this store module
  state() {
    return {
      invocies: [],
      returnCustDoc: [],
      OpenInvoices: 0,
      OpenReturnCustDocs: 0,
    };
  },
  mutations: {
    setInvoices(state, invoicesList) {
      state.invocies = invoicesList;
      this.commit("Invoices/setOpenInvoices");
    },
    setReturnCustDocs(state, returnCustDocsList) {
      state.returnCustDoc = returnCustDocsList;
      this.commit("Invoices/setOpenReturnCustDocs");
    },
    setOpenReturnCustDocs(state) {
      let total = 0;
      state.returnCustDoc.forEach((returnCustDoc) => {
        if (returnCustDoc?.Status?.activeorder) {
          total += 1;
        }
      });
      state.OpenReturnCustDocs = total;
    },
    setOpenInvoices(state) {
      let total = 0;
      state.invocies.forEach((invoice) => {
        if (invoice?.Status?.activeorder) {
          total += 1;
        }
      });
      state.OpenInvoices = total;
    },
  },
  actions: {
    async getInvoice(state, docId) {
      if (!docId) return;
      try {
        const response = await InvoiceService.getInvoice(docId);
        return response.data;
      } catch (error) {
        console.log(error);
        return {};
      }
    },
    updateInvoices(context, data) {
      context.commit("setInvoices", data);
    },
    updateReturnCustDocs(context, data) {
      context.commit("setReturnCustDocs", data);
    },
    async sendInvoiceDebtRequest(context, data) {
      try {
        store.dispatch("startLoading", null, { root: true });
        await InvoiceService.sendInvoiceDebtRequest(data);
        return true;
      } catch (error) {
        console.log(error);
        context.dispatch(
          "ShowToast",
          {
            message: "הייתה בעיה בעת שליחת הבקשה",
            status: "error",
          },
          { root: true }
        );
        return false;
      } finally {
        store.dispatch("stopLoading", null, { root: true });
      }
      // context.commit("setReturnCustDocs", data);
    },
    async getAwaitingReturnCustDocs() {
      const response = await InvoiceService.getAwaitingReturnCustDocs();
      return response.data;
    },
  },
  getters: {
    getOpenInvoices(state) {
      return state.OpenInvoices;
    },
    getOpenReturnCustDocs(state) {
      return state.OpenReturnCustDocs;
    },
    getOpenReturnCustDocsAndInvoices(state) {
      return state.OpenReturnCustDocs + state.OpenInvoices;
    },
    getInvoices(state) {
      return state.invocies;
    },
    getReturnCustDocs(state) {
      return state.returnCustDoc;
    },
    getInvoice: (state) => (docId) => {
      if (docId == "cart") {
        return state.Cart;
      } else {
        return state.invocies.find((invoice) => invoice.docId == docId);
      }
    },
    getReturnCustDoc: (state) => (docno) => {
      for (let returnCustDoc of state.returnCustDoc)
        if (returnCustDoc.docno == docno) {
          return returnCustDoc;
        }
      return {};
    },
    getInvoicesStatuses(state) {
      let statusList = {};
      if (!state.invocies) return statusList;
      for (let invoice of state.invocies) {
        if (typeof statusList[invoice?.Status?.statdes] === "undefined")
          statusList[invoice?.Status?.statdes] = {
            id: invoice?.Status?.statdes,
            name: invoice?.Status?.statusname,
            count: 0,
            enName: invoice?.Status?.estatusname,
          };
        statusList[invoice?.Status?.statdes].count++;
      }
      return statusList;
    },
    getReturnCustDocsStatuses(state) {
      let statusList = {};
      if (!state.returnCustDoc) return statusList;
      for (let returncustdoc of state.returnCustDoc) {
        if (typeof statusList[returncustdoc?.Status?.statdes] === "undefined")
          statusList[returncustdoc?.Status?.statdes] = {
            id: returncustdoc?.Status?.statdes,
            name: returncustdoc?.Status?.statusname,
            count: 0,
            enName: returncustdoc?.Status?.estatusname,
          };
        statusList[returncustdoc?.Status?.statdes].count++;
      }
      return statusList;
    },
  },
};
